export default __webpack_public_path__ + "static/media/welcome.2f6285ac.jpg";